import { PacksClient } from './namespaced/PacksClient';
import { ProfileClient } from './namespaced/ProfileClient';
import { BaseApiClientOptions } from './base/BaseApiClient';
import { GroupsClient } from './namespaced/GroupsClient';
import { ModerationClient } from './namespaced/ModerationClient';

export class GoFeralApiClient {
  packs: PacksClient;
  groups: GroupsClient;
  profile: ProfileClient;
  moderation: ModerationClient;

  constructor(options: BaseApiClientOptions) {
    this.profile = new ProfileClient(options);
    this.packs = new PacksClient(options);
    this.groups = new GroupsClient(options);
    this.moderation = new ModerationClient(options);
  }
}
